import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../data/translations';

// New ambient video - portrait 9:16
const VIDEO_URL = '/assets/migrated/5840ec8ec68c0e16.mp4';

const VideoSection = () => {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setShouldLoadVideo(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Auto-play video when it becomes visible
  useEffect(() => {
    if (shouldLoadVideo && videoRef.current) {
      videoRef.current.play().catch(() => {
        // Autoplay was prevented, that's ok
      });
    }
  }, [shouldLoadVideo]);

  return (
    <section
      ref={sectionRef}
      className="relative pt-0 pb-10 md:py-20 overflow-hidden"
    >
      {/* Transparent - stars show through */}

      <div className="relative z-10 max-w-md md:max-w-lg mx-auto px-4 md:px-6">
        <div className={`transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          {/* Section header - spacing controlled at section level */}
          <div className="text-center mb-4 md:mb-8 pt-0 md:pt-0">
            <p className="text-amber-200/50 font-serif text-sm md:text-base" style={{ margin: 0 }}>
              {t(translations.video.peek)}
            </p>
          </div>

          {/* Video container - portrait 9:16, ambient visual */}
          <div className="relative rounded-xl md:rounded-2xl overflow-hidden border border-[#c9a87c]/15 shadow-lg bg-[#0d0d18]">
            {/* Video element - portrait aspect (9:16), autoplay ambient */}
            {shouldLoadVideo && (
              <video
                ref={videoRef}
                className="w-full aspect-[9/16] object-cover bg-[#0d0d18]"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
              >
                <source 
                  src={VIDEO_URL}
                  type="video/mp4" 
                />
                Your browser does not support the video tag.
              </video>
            )}
            {/* Placeholder while video loads */}
            {!shouldLoadVideo && (
              <div className="w-full aspect-[9/16] bg-[#0d0d18]" />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
